import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import AutoCompleteSingle from '../../common/AutoCompleteSingle';
import FolderIcon from '../../icons/folder.svg';

function Header({
    allProjects,
    selectedProject,
    handleSelectProject,
    statusDataSource,
    numAccepted,
    total,
    fullScreenHandler,
}) {
    const toPercent = (num, total) => {
        if (total) {
            const percentage = (100 * num) / total;
            return percentage.toFixed(0);
        } else return '--';
    };

    const ProjectStatus = () => {
        return (
            <Card>
                <Grid container className="mx-4 mb-2">
                    <Grid item md>
                        <p className="my-2 text-left">
                            <strong>{`${statusDataSource}s`}</strong>
                        </p>
                    </Grid>
                    <Grid item md>
                        <p className="my-2 text-center">
                            <strong>{toPercent(numAccepted, total)}</strong>{' '}
                            {'%'}
                        </p>
                    </Grid>
                    <Grid item md>
                        <p className="my-2 text-center">
                            <strong>{numAccepted}</strong> Accepted /{' '}
                            <strong>{total}</strong> Required
                        </p>
                    </Grid>
                </Grid>
            </Card>
        );
    };

    // eslint-disable-next-line no-unused-vars
    const handleFullScreen = () => {
        if (!fullScreenHandler.active) {
            fullScreenHandler.enter();
        } else {
            fullScreenHandler.exit();
        }
    };

    return (
        <>
            <div className="col-3 mt-n2">
                <AutoCompleteSingle
                    id="projectSelector"
                    bootstrapIcon={FolderIcon}
                    stylesIcon={{
                        justifyContent: 'center',
                    }}
                    placeholder={'Select Project'}
                    noOptionsText={'No Projects Found'}
                    options={allProjects}
                    renderOption={(option) => option.name}
                    value={selectedProject}
                    onSelect={handleSelectProject}
                    style={{
                        backgroundColor: '#ffffff',
                        borderRadius: '5px',
                    }}
                />
            </div>
            <div className="col">
                <ProjectStatus />
            </div>
            {/* TODO: Bring back fullscreen button */}
            {/* <div className="col-2 ml-2 d-flex justify-content-end fullScreenBtn">
                <button className="btn btn-primary" onClick={handleFullScreen}>
                    FullScreen
                </button>
            </div> */}
        </>
    );
}

Header.propTypes = {
    allProjects: PropTypes.array,
    selectedProject: PropTypes.object,
    handleSelectProject: PropTypes.func,
    statusDataSource: PropTypes.string,
    numAccepted: PropTypes.number,
    total: PropTypes.number,
    fullScreenHandler: PropTypes.object,
};

export default Header;
